import { DatePipe } from '@angular/common';
import { TranslatePipe } from '../../filters/translate.pipe';
import {Component, OnInit, OnDestroy, inject, HostListener} from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import Session from '../../utils/session.service';
import AngularHelperService from '../../services/angular-helper.service';
import { Input } from '@angular/core';
import AngularBroadcastHelperService from "../../services/angular-broadcast-helper.service";
import AngularFilterHelperService from "../../services/angular-filter-helper.service";
import ChatRestServices from "../../services/chat-rest.service";
import Config from "../../utils/config.service";
import DialogServices from "../../services/dialog.service";

declare const mdqstnr: any;

@Component({
	standalone: true,
	selector: 'item-message-questionnaire-request',
	templateUrl: './item-message-questionnaire-request.component.html',
	imports: [ CommonModule, DatePipe, TranslatePipe, FormsModule ]
})
export class ItemMessageQuestionnaireRequestComponent implements OnInit, OnDestroy {
	private session: Session = inject(Session);
	private angularHelperService: AngularHelperService = inject(AngularHelperService);
	private angularBroadcastHelperService: AngularBroadcastHelperService = inject(AngularBroadcastHelperService);
	private angularFilterHelperService: AngularFilterHelperService = inject(AngularFilterHelperService);
	private chatRestServices: ChatRestServices = inject(ChatRestServices);
	private config: Config = inject(Config);
	private dialogServices: DialogServices = inject(DialogServices);
	
	@Input() lastSeen: any | undefined;
	@Input() chat: any;
	@Input() group: any;
	
	vm: any = undefined;
	watcher: any = undefined;
	activeMessage: any | null = null;
	isDesktop = window.innerWidth >= 768;
	
	constructor() {
		this.vm = this;
	}
	
	ngOnInit() {
		this.vm.user = this.session.getSession().user;
		this.vm.isDoctor = this.vm.user.businessUserType === 'SERVICE_PROVIDER';
		this.vm.message = this.vm.group.messages[0];
		this.vm.uid = 'iqr-' + this.vm.message.id;
		
		this.loadMetadata();
		
		this.vm.startAnswering = this.startAnswering;
		this.vm.viewResults = this.viewResults;
		this.vm.onMouseLeave = this.onMouseLeave;
		this.vm.onMouseEnter = this.onMouseEnter;
		this.vm.deleteMessage = this.deleteMessage;
		this.vm.toggleActions = this.toggleActions;

		var scriptSrc = 'https://apps-content.s3.eu-west-1.amazonaws.com/questionnaire/questionnaire-3.0.4.js';
		this.initQuestionnairePlugin(window, document, 'script', 'mdqstnr', scriptSrc);
		
		var currentIsCompleted = undefined;
		this.watcher = this.angularHelperService.createInterval(() => {
			if (this.vm.message.isCompleted !== currentIsCompleted) {
				currentIsCompleted = this.vm.message.isCompleted;
				this.loadMetadata();
			}
		}, 300);
	}
	
	ngOnDestroy() {
		if (this.watcher) {
			this.angularHelperService.cancelInterval(this.watcher);
		}
	}
	
	initQuestionnairePlugin(m, i, n, u, d, o?, c?) {
		m.MinudocObject = u, m.mdqstnr = m.mdqstnr || function() { (m.mdqstnr.q = m.mdqstnr.q || []).push(arguments) },
			o = i.createElement(n), c = i.getElementsByTagName(n)[0], o.id = u, o.src = d,
			o.async = 1, c.parentNode.insertBefore(o, c);
	}
	
	startAnswering() {
		var config: any = {
			language: this.vm.metadata.language,
			codeName: this.vm.metadata.questionnaire.codeName,
			environment: this.vm.metadata.environment,
			origin: this.vm.user.origin,
			hideResultsLink: true,
			showCutOffScore: true,
			submitDisabled: this.vm.isDoctor
		};
		if (this.vm.metadata.id) {
			config.requestId = this.vm.metadata.id;
		}
		mdqstnr('init', config);
	}
	
	viewResults() {
		var config: any = {
			language: this.vm.user.deviceLanguage,
			codeName: this.vm.metadata.questionnaire.codeName,
			environment: this.vm.metadata.environment,
			origin: this.vm.user.origin,
			hideResultsLink: true,
			showCutOffScore: true,
			submitDisabled: false,
			token: this.vm.metadata.userQuestionnaire.token
		};
		if (this.vm.metadata.id) {
			config.requestId = this.vm.metadata.id;
		}
		mdqstnr('showAnsweredQuestionnaire', config);
	}
	
	loadMetadata() {
		var metadata: any = this.vm.message && this.vm.message.metadatas && this.vm.message.metadatas.find(function(item) {
			return item.type === 'QUESTIONNAIRE_REQUEST';
		});
		
		if (metadata) {
			try {
				this.vm.metadata = JSON.parse(metadata.metadata);
				this.vm.metadata.type = metadata.type;
			} catch (e) {
				console.error(e);
			}
		}
	}
	onMouseEnter(message: any) {
		if (this.isDesktop) {
			message.showDots = true;
		}
	}

	onMouseLeave(message: any) {
		if (this.isDesktop) {
			message.showDots = false;
		}
	}

	toggleActions(message: any, event: Event, container: HTMLElement) {
		event.stopPropagation();
		message.showActions = !message.showActions;

		message.showDots = true;

		this.activeMessage = message.showActions ? { message, container } : null;
	}

	@HostListener('document:click', ['$event'])
	onClickOutside(event: Event) {
		if (!this.activeMessage) return;

		const target = event.target as HTMLElement;
		const { message, container } = this.activeMessage;

		if (message.showActions && container && !container.contains(target)) {
			message.showActions = false;
			if (this.isDesktop) message.showDots = false;
			this.activeMessage = null;
		}
	}


	deleteMessage(message: any) {
		this.handleDeleteMessage(message);
	}

	handleDeleteMessage(textMessage: any) {
		var dialog = this.dialogServices.confirmation({
			title: this.angularFilterHelperService.translate('Modal.Title.Confirm'),
			content: this.angularFilterHelperService.translate('Modal.Content.Delete_Message_Confirmation'),
		});
		dialog.afterClosed().subscribe((data) => {
			if (data) {
				this.vm.loading = true;
				var chat: any = this.angularHelperService.copy(this.vm.chat);
				var message: any = {
					id: textMessage.id,
					content: this.angularFilterHelperService.translate('Chats.Other.Deleted'),
					chat: {
						id: this.vm.chat.id
					}
				};
				this.chatRestServices.updateChatMessage(
					{ forUser: this.vm.chat.privateChatFriend.id, isDeleted: true }, message,
					(res) => {
						this.vm.loading = false;
						this.angularBroadcastHelperService.rootBroadcast(this.config.getBroadcastConfig().Chat.CHAT_POST_DELETED, [res], chat.id);
					},
					(err) => {
						console.error(err);
						this.vm.loading = false;
					}
				);
			}
		});
	}
	
}